module.exports = __webpack_public_path__ + "assets/img/m222.69b81684.png";